import { render, staticRenderFns } from "./vatin-box.vue?vue&type=template&id=02736bea&scoped=true"
import script from "./vatin-box.vue?vue&type=script&lang=js"
export * from "./vatin-box.vue?vue&type=script&lang=js"
import style0 from "./vatin-box.vue?vue&type=style&index=0&id=02736bea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02736bea",
  null
  
)

export default component.exports